import {Validators} from "@angular/forms";

/**
 * host
 * Group
 * @param fb : FormBuilder
 */
export function hostGroup (fb) {
   return fb.group({
       host: [[], Validators.required],
   });
}
